function handle_form_errors() {

    /**
     * Função que pega um array de campos hidden de erros,
     * e posiciona estes erros abaixo do campo devido.
     */

    var message;

    $.each($('input.errors'), function (key, input) {

        /* Posiciona as mensagens de erro */

        message = $('#messages_'+input.value).val();

        $('<div class="help-block">'+message+'</div>').insertAfter( '#'+input.value );

        /* Formata os groups com erro */

        $('#'+input.value).parent().addClass('has-error');

    });
}

function excluirRegistro(event) {
    event.preventDefault();
    swal({
            title: "Atenção",
            text: "Deseja realmente excluir o registro especificado?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Sim, excluir!",
            closeOnConfirm: false
        },
        function(){
            var link = event.currentTarget;
            window.location = link.href;
        });
}

/**
 * Desmarca todas as formas de ensino quando alterado entre (Ensino Presencial) e (EAD - Ensino a Distancia).
 */
function resetFormaEnsino() {
    $("#bloco_forma_ensino").find('.check-filial-id, .check-polo-id').iCheck('uncheck');
}

/**
 * Define a funcao a ser chamada quando as abas da Forma de ensino forem alteradas.
 */
function setarBotoesFormaEnsino() {
    $("#bloco_forma_ensino .btn-forma-ensino").on('shown.bs.tab', function() {
        resetFormaEnsino();
    });
}